var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('smart-id-signing',_vm._g({attrs:{"visible":"","start-signing":_vm.startSigning,"complete-signing":_vm.completeSigning}},_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }